import styled from "styled-components";
import React from "react";
import { TextInputWTitleDisable } from "../inputs/TextInputWTitleDisable";
import { InputTitle } from "../inputs/InputTitle";
import { CheckboxProfile } from "../inputs/CheckboxProfile";
import { SelectDateInputDisabled } from "../inputs/SelectDateInputDisabled";

const StyleCss = styled.div`
  grid-column: 1 / 13;
  width: auto !important;
  .loading-ep {
    display: flex;
    justify-content: center;
    margin: 100px auto 0;
  }
  .container {
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 40px 40px 40px 20px;
    .rightelement,
    .leftelement {
      width: 48%;
    }
    .full-width {
      width: 100%;
    }
    .vertical-devider {
      width: 1px;
      border-left: 1px solid var(--n-grey-3);
    }
    .row {
      margin: 2rem 0;
      padding: 0 10px;
      :first-child{
        margin: 0 0 2rem;
      }
      .textarea {
        height: 5rem !important;
        width: 50% !important;
      }
      .new-input {
        padding: 0 calc(1rem - 1px);
      }
      .image-file {
        display: flex;
        width: calc(100% - 1rem);
        padding: 0.5rem;
        border-radius: var(--border-radius);
        border: 1px solid var(--n-grey-3);
        background-color: var(--n-grey-1);
        outline: none;
        transition: var(--trans-1);
        font-size: var(--fs-textfield);
        .texts {
          width: calc(60% - 1.5rem);
          margin: 0 0.5rem 0 1rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            margin: 6px 0;
            font-size: 11px;
            font-weight: 500;
          }
          .desc {
            font-size: 11px;
            font-weight: normal;
            text-align: justify;
            color: var(--n-grey-7);
          }
        }
        .image {
          width: 40%;
          padding-top: 40%;
          position: relative;
          border-radius: 16px;
          overflow: hidden;
          img {
            width: 100%;
            position: absolute;
            inset: 0 0 0 0;
            display: block;
            background-color: var(--n-grey-3);
          }
        }
      }
    }
  }
`;


function PersonalDataShow(props) {
  let data = props.userdata
  return (
    <StyleCss>
      <div className="container">
        <div className="rightelement">
          <div className="row">
            <TextInputWTitleDisable
              value={data.Email}
              title={'Email'}
            />
          </div>
          <div className="row">
            <TextInputWTitleDisable
              value={data.FName}
              title={'First Name'}
            />
          </div>
          <div className="row">
            <TextInputWTitleDisable
              value={data.LName}
              title={'Last Name'}
            />
          </div>
          <div className="row">
            <TextInputWTitleDisable
              value={data.Code}
              title={'National Code'}
            />
          </div>
          {/* <div className="row">
            <div className="new-input">
              <InputTitle>Gender</InputTitle>
              <CheckboxProfile value={data.Gender} name={'Gender'} disabled={true}/>
            </div>
          </div>
          <div className="row">
            <div className="new-input">
              <InputTitle>Birthdate</InputTitle>
              <SelectDateInputDisabled value={data.Birthday} name={'birthday'} error={''} disabled={true}/>
            </div>
          </div> */}
        </div>
        <div className='vertical-devider'></div>
        <div className="leftelement">
          <div className="row">
            <TextInputWTitleDisable
              value={data.Mobile}
              title={'Mobile'}
              help={'For changing mobile number contact support'}
            />
          </div>
        </div>
      </div>
    </StyleCss>
  );
}
export default PersonalDataShow;
